import Compressor from 'compressorjs'
import firebase from 'firebase'
import SystemConstants from '@app/constants/SystemConstants'

// fileの圧縮
export function compress(file: File) {
  return new Promise<File | Blob | undefined>((resolve, reject) => {
    new Compressor(file, {
      quality: SystemConstants.imageCompress.quality,
      maxWidth: SystemConstants.imageCompress.maxWidth,
      success: (result) => {
        const compressedFile = new File([result], file.name)
        resolve(compressedFile)
      },
      error: (e) => {
        reject(undefined)
      },
    })
  })
}

export function getExtentionName(path: string): string | undefined {
  const extension = path.split('.').pop()
  return extension
}

export async function getStorageUrl(path: string) {
  const ref = firebase.storage().ref(path)
  const url = await ref.getDownloadURL()
  return url
}

// firebase storageに画像をアップする
export function uploadStorage(file: File, path: string) {
  return new Promise<string>(async (resolve, reject) => {
    const storageRef = firebase.storage().ref()
    const compressImage = await compress(file)
    const postImage = compressImage ? compressImage : file
    const uploadTask = storageRef.child(path).put(postImage)
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        console.log('success')
      },
      (error) => {
        console.log(error)
        reject(error)
      },
      () => {
        uploadTask.snapshot.ref
          .getDownloadURL()
          .then((downloadURL) => {
            // ファイルアップロードして使えるようになったときの処理
            resolve(downloadURL)
          })
          .catch((e) => {
            reject(e)
          })
      }
    )
  })
}
